import React, { useState, useRef } from 'react';
import clsx from 'clsx';

// prop types
interface VideoPlayerProps {
    youtubeVideoId?: string;
    image?: {
        link: string;
        alt: string;
        title: string;
    };
    internalVideo?: string;
    autoplay?: boolean;
    className?: string;
}

export default function VideoPlayer({
    internalVideo,
    image,
    youtubeVideoId,
    autoplay = false,
    className
}: VideoPlayerProps) {
    const classes = clsx(
        'video-player',
        className
    );

    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    const figureRef = useRef<HTMLImageElement>(null);
    const playButtonRef = useRef<HTMLButtonElement>(null);

    const handlePlay = () => {
        if (videoRef.current && !isPlaying) {
            playButtonRef.current.style.display = 'none';
            figureRef.current.style.display = 'none';
            videoRef.current.play();
            setIsPlaying(true);
        }
    };

    return (
        <div className={classes}>
            {(internalVideo && image) ? (
                <div className="videoWrapper videoWrapper--video">
                    <video ref={videoRef} controls loop>
                        <source src={internalVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <figure ref={figureRef} className="img aspectRatio--16x9">
                        <img
                            alt={image?.alt}
                            src={image?.link}
                            title={image?.title}
                        />
                    </figure>

                    <button ref={playButtonRef} className="playButton" onClick={handlePlay} title="Play video"></button>
                </div>
            ) : (
                youtubeVideoId ? (
                    <div className="videoWrapper--video">
                        <iframe
                            src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=${autoplay ? 1 : 0}&mute=${autoplay ? 1 : 0}`}
                            title={internalVideo ? 'Video player' : 'YouTube video player'}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                ) : (
                    <p>No video available</p>
                )
            )}
        </div>
    );
}
